import { render, staticRenderFns } from "./PlayfieldCard.vue?vue&type=template&id=032091f4&scoped=true&"
import script from "./PlayfieldCard.vue?vue&type=script&lang=js&"
export * from "./PlayfieldCard.vue?vue&type=script&lang=js&"
import style0 from "./PlayfieldCard.vue?vue&type=style&index=0&id=032091f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032091f4",
  null
  
)

export default component.exports